/* eslint-disable react/button-has-type */
// after reading in online source, it seems eslint is buggy

import React from 'react';
import './style.scss';
import { Spinner } from 'react-bootstrap';

interface Props {
    id?: string
    onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined
    disabled?: boolean | undefined
    className?: string | undefined
    type?: 'button' | 'submit' | 'reset'
    size?: 'lg' | 'md' | 'sm'
    outline?: boolean | undefined
    title?: string | undefined

    /* label will hide if undefined */
    label?: string | undefined

    /* can be used to give spinner if loading is true */
    loading?: boolean | undefined;

    isButton?: boolean | undefined;
    style?: React.CSSProperties | undefined
}

const Default:React.FC<Props> = (props) => {
  const {
    className, id, type = 'button', onClick, label,
    disabled, loading, size = 'md', outline, title,
    isButton = true, style,
  } = props;

  const renderSize = () => {
    if (outline) {
      if (size === 'lg') return 'height-outline-lg';
      if (size === 'sm') return 'height-outline-sm';
      return 'height-outline-md';
    }
    if (size === 'lg') return 'height-button-lg';
    if (size === 'sm') return 'height-button-sm';
    return 'height-button-md';
  };
  const renderOutline = () => (outline ? 'button-container-outline' : 'button-container');

  return (
    <div>
      {isButton ? (
        <button
          id={id}
          type={type}
          disabled={loading || disabled}
          onClick={onClick}
          className={`${renderOutline()} ${className} ${renderSize()}`}
          title={title}
          style={style}
        >
          <div className={!loading ? '' : 'd-none'}>{ label }</div>
          <Spinner className={loading ? 'fz-12' : 'd-none'} animation="border" size="sm" />
        </button>
      ) : (
        <div
          id={id}
          className={`${renderOutline()} ${className} ${renderSize()}`}
          style={style}
        >
          <div>{ label }</div>
        </div>
      )}

    </div>
  );
};

export default Default;
